import type { ContentScope } from '@/types/contentScope'
import type { Partner } from './types'

export type TargetAudience = 'all' | 'loyal' | 'segment'
export type DistributionChannel = 'in_store' | 'kiosk' | 'click_collect' | 'online' | 'delivery'
export type ActiveDay = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'
export type UsageLimit = 'none' | 'unlimited' | 'quantity'
export type ApplyReductionOn = 'cart' | 'products'
export type AccessCondition = 'none' | 'min_amount' | 'products_required' | 'cart_item_count'

export const DAY_TO_NUMBER: Record<ActiveDay, number> = {
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6,
  sun: 7
}

export const NUMBER_TO_DAY = Object.fromEntries(
  Object.entries(DAY_TO_NUMBER).map(([day, num]) => [num, day])
) as Record<number, ActiveDay>

export const ACTIVE_DAYS = Object.keys(DAY_TO_NUMBER) as ActiveDay[]

export interface TimeSlot {
  id: number
  days: ActiveDay[]
  startTime: string
  endTime: string
}

export interface OfferFormSnapshot {
  scope: ContentScope | null
  name: string
  description: string
  rewardId: number | null
  startDate: string | null
  endDate: string | null
  targetAudience: TargetAudience
  selectedSegmentIds: number[]
  excludedSegmentIds: number[]
  storeIds: number[]
  channels: DistributionChannel[]
  claimLimitQuantity: number | null
  claimLimitDays: number | null
  isPromotionalCodeRequired: boolean
  timeSlots: Array<{
    days: ActiveDay[]
    startTime: string
    endTime: string
  }>
}

export interface PartnerParameterResponse {
  id: number
  partner: Partner
}

export type PartnerWithAccounts = Partner & {
  accounts: PartnerParameterResponse[]
}
